import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as HomeIcon } from '../../assets/icons/home.svg';
import { ReactComponent as LoginIcon } from '../../assets/icons/login.svg';
import { ReactComponent as RegisterIcon } from '../../assets/icons/register.svg';
import { ReactComponent as MapIcon } from '../../assets/icons/map.svg';
import { ReactComponent as MenuIcon } from '../../assets/icons/menu.svg';
import { ReactComponent as ProfileIcon } from '../../assets/icons/profile-pic.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout.svg';
import { ReactComponent as AdminIcon } from '../../assets/icons/admin.svg';
import Home from '../../Pages/Index';
import Login from '../../Pages/Login';
import Register from '../../Pages/Register';
import Map from '../../Pages/Map';
import Profile from '../User/Profile';
import Logout from '../User/Logout';
import Admin from '../../Admin/Pages/Index';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import MenuModal from 'react-modal';
import { useIsAuthenticated, useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function LoggedOutView(props) {


    return (
        <nav className="desktopNav">
            <ul>
                <li>
                    <Link to="/" element={<Home />}><HomeIcon className="icon" /></Link> <Link to="/">Home</Link></li>
                <li><Link to="/Login"><LoginIcon className="icon" /></Link> <Link to="/Login">Login</Link></li>
                <li><Link to="/Register" ><RegisterIcon className="icon" /></Link><Link to="/Register">Register</Link></li>
                <li><Link to="/Map"><MapIcon className="icon" /></Link><Link to="/Map">Map</Link></li>
            </ul>
        </nav>
    )
}


function LoggedInView(props) {
    if (props.role === null) {
        return (
            <nav className="desktopNav">
                <ul>
                    <li><Link to="/" element={<Home />}><HomeIcon className="icon" /></Link> <Link className="icon" to="/">Home</Link></li>
                    <li><Link to="/User/Profile" element={<Profile />}><ProfileIcon className="icon" /></Link> <Link to="/User/Profile">Profile</Link></li>
                    <li><Link to="/User/Logout" element={<Logout />}><LogoutIcon className="icon" /></Link> <Link to="/User/Logout">Logout</Link></li>
                </ul>
            </nav>
        )
    } else {
        return (
            <nav className="desktopNav">
                <ul>
                    <li><Link to="/" element={<Home />}><HomeIcon className="icon" /></Link> <Link className="icon" to="/">Home</Link></li>
                    <li><Link to="/User/Profile" element={<Profile />}><ProfileIcon className="icon" /></Link> <Link to="/User/Profile">Profile</Link></li>
                    <li><Link to="/User/Logout" element={<Logout />}><LogoutIcon className="icon" /></Link> <Link to="/User/Logout">Logout</Link></li>
                    <li><Link to="/Admin" element={<Admin />}><AdminIcon className="icon" /></Link> <Link to="/Admin" element={<Admin />}>Admin</Link>
                        <ul>
                            <li><Link to="/Admin/Users">Users</Link></li>
                            <li><Link to="/Admin/Roles">Roles</Link></li>
                            <li><Link to="/Admin/Appointments">Appointments</Link></li>
                        </ul>
                    </li>

                </ul>
            </nav>
        )
    }
}



export default function Header(props) {

    const isAuthenticated = useIsAuthenticated();
    const user = useAuthUser();
    const roleRef = useRef();
    const [role, setRole] = useState([]);

    useEffect(() => {
        if (isAuthenticated()) {
            axios.post('http://localhost:5000/Roles/UserRoles', { id: user().id })
                .then((response) => {
                    setRole(response.data);

                })
                .catch((error) => {
                    console.log(error);
                })
        }

    })

    if (isAuthenticated()) {
        return (<LoggedInView role={role} />);
    } else {
        return (<LoggedOutView />);
    }

}
